/**
 * File: /hbbtv-lib/tools/query_string.js
 * 
 * (C) IRT GmbH 2017
 * 
 * Query string parser
 * 
 * Provides key value pair based query strings. The query (search) string will be parsed upon module loading.
 * 
 * Usage: 
 * var qs = require('hbbtv-lib/tools/query_string');
 * var value = qs.get(key);
 */

function parameters (l) {
    var qs_map = {};
    function parse(x) {
        if (x && x.length > 0) {
            x = x.substr(1).split("&");
            for (i in x) {
                var y = x[i].split("=");
                if (y && y.length == 2) {
                    qs_map[y[0]] = y[1];
                }
            }
        }
    }
    parse(l.search);
    parse(l.hash);
    return {
        get : function (key, def) {
            if (key in qs_map) {
                return qs_map[key];
            }
            return def;
        }
    }    
}

var params = parameters(window.location);

module.exports = {
    get : params.get,
    parse : function (url) {
        var location;
        if (url && url.search && url.hash) {
            location = url;
        } else if (typeof url == "string" && url.length > 0) {
            location = document.createElement('a');
            location.href = url;
        } else return null;

        return parameters(location);
    }
};